import { Record } from "immutable";

export type QuizModuleStatType = {
  marksTotal?: number;
  bestModuleMark?: number;
  worstModuleMark?: number;
  averageSessionMark?: number;
  bestSessionMark?: number;
  worstSessionMark?: number;
  firstSessionMark?: number;
  lastSessionMark?: number;
};

export const defaultQuizModuleStat: QuizModuleStatType = {
  marksTotal: undefined,
  bestModuleMark: undefined,
  worstModuleMark: undefined,
  averageSessionMark: undefined,
  bestSessionMark: undefined,
  worstSessionMark: undefined,
  firstSessionMark: undefined,
  lastSessionMark: undefined
};

export default class QuizModuleStat extends Record(defaultQuizModuleStat) {}
